<template>
  	<OnlineTransactionReport />
</template>

<script>

// @ is an alias to /src
import OnlineTransactionReport from "@/components/reports/Transaction/OnlineTransactionReport.vue";

export default {
  name: "OnlineTransactionReportView",
  components: {
    OnlineTransactionReport,
  },
};
</script>
